export const toOption =
  (translator = null, prefix = null) =>
  (str) => {
    if (translator) {
      return { key: str, label: prefix ? translator(`${prefix}.${str}`) : translator(str), value: str };
    } else {
      return { key: str, label: str, value: str };
    }
  };
